import * as React from 'react';
import './headerItem.module.scss';
import classNames from 'classnames';

type Props = {
    color: 'white' | 'dark';
    children: any;
    onClick?: any;
};

export const HeaderItem = ({ onClick, color, children }: Props) => {
    return (
        <div styleName={classNames('header-item', color)} onClick={onClick}>
            {children}
        </div>
    );
};

export const HeaderItemMainText = ({ children }) => <div styleName="header-item-main-text">{children}</div>;
export const HeaderItemSubText = ({ children }) => <div styleName="header-item-sub-text">{children}</div>;
